<div>
    <button class="btn btn-primary mr-1 btn-pading" title="Edit"  [disabled]="!isTemporary" (click)="onEdit($event)"><i class="fa fa-solid fa-pencil-square-o"></i></button>
    <button class="btn btn-primary btn-pading" title="Delete" [disabled]="!isTemporary" (click)="onDelete($event)"><i class="fa fa-solid fa-trash"></i></button>
</div>


<ng-template #callAPIDialog>
    <div class="modal-content text-center p-4">
      <h4 class="mb-4">Do you want to delete "{{mno}}"?</h4>
      <div class="d-flex justify-content-center gap-3">
        <button 
          type="button" 
          class="btn btn-danger px-3"
          (click)="onCancel()">
          Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-primary px-3"
          (click)="deleteData()">
          Delete
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template #deleteCheckDialog >
   
        <div class="modal-content text-center p-4">
            <div class="fullscreen">
                <div class="modal-body" style="height: 30vh; overflow-y: auto;">
                    <div class="mt-4" style="text-align: center;">
                        <h6> This MNO is used by one or more MNO Mappings.</h6>
                        <h6>If you wish to edit or delete the MNO Map, first remove it from all the MNO Mappings where it's
                            currently added to.</h6>
                        <div class="mt-4">
                            <button type="button" class="btn btn-danger" style="margin-right: 1rem; width: 75px;" (click)="onCancel()">
                                Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
</ng-template>
  